import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: '产品', href: '#features' },
    { label: '功能', href: '#functions' },
    { label: '定价', href: '#pricing' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2.5">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20geometric%20logo%20icon%20for%20a%20file%20system%20cloud%20storage%20brand%2C%20clean%20simple%20shape%20with%20rounded%20corners%2C%20flat%20design%2C%20white%20transparent%20background%2C%20professional%20tech%20company%20identity%2C%20single%20symbol&width=200&height=200&seq=logo-tianyi-fs&orientation=squarish"
            alt="Tianyi Logo"
            className="w-7 h-7 md:w-8 md:h-8 object-contain"
          />
          <span
            className={`font-heading text-2xl md:text-3xl font-bold tracking-tight whitespace-nowrap ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            Tianyi
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'text-foreground-700 hover:text-foreground-950'
                  : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <a
            href="#pricing"
            className={`text-sm font-medium px-5 py-2 rounded-full border transition-all whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'border-foreground-300 text-foreground-700 hover:border-foreground-500 hover:text-foreground-950'
                : 'border-background-50/50 text-background-50 hover:border-background-50 hover:bg-background-50/10'
            }`}
          >
            登录
          </a>
          <a
            href="#pricing"
            className="text-sm font-medium px-5 py-2 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            免费试用
          </a>
        </div>

        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled ? 'text-foreground-900' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-foreground-700 hover:text-foreground-950 text-sm font-medium py-2 cursor-pointer"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 pt-2 border-t border-background-200/70">
              <a
                href="#pricing"
                className="text-sm font-medium text-foreground-700 py-2 cursor-pointer"
                onClick={() => setMobileOpen(false)}
              >
                登录
              </a>
              <a
                href="#pricing"
                className="text-sm font-medium px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-center whitespace-nowrap cursor-pointer"
                onClick={() => setMobileOpen(false)}
              >
                免费试用
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}